import { CirclePause } from 'lucide-react';
import Badge from '../../ui/Badge';

// Backburner is parked, not a condition (ui/stages.js), but the list's Condition cell, its panel and the editor header
// mark it with its own browner amber (--status-backburner), apart from the warn amber and the Ember accent.
export default function BackburnerBadge() {
  return <Badge tone="backburner" icon={CirclePause}>Backburner</Badge>;
}
